var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "right-arrow-4 1",
    clipPath: "url(#clip0_3069_1105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000069389879055801571320000011536833412356631485_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.749023 12.3896L8.05371 5.02637C8.39062 4.68945 8.9375 4.68457 9.27441 5.02148C9.61133 5.3584 9.61621 5.90527 9.2793 6.24219L3.43457 12.1357H24.6357C25.1143 12.1357 25.5 12.5215 25.5 13C25.5 13.4785 25.1143 13.8643 24.6357 13.8643H3.43457L9.2793 19.7578C9.61621 20.0947 9.61133 20.6416 9.27441 20.9785C8.9375 21.3154 8.39062 21.3105 8.05371 20.9736L0.749023 13.6103C0.416992 13.2734 0.416992 12.7266 0.749023 12.3896Z",
    fill: "#292929"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_1105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "matrix(-1 0 0 1 25.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.aa30c436d8f3de0aad76ebc0dbcc2638.svg";
export { ForwardRef as ReactComponent };